import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import IconDaggerheart from '../common/IconDaggerheart';
import HelpButton from '../common/HelpButton';
import UserMenu from '../common/UserMenu';

/**
 * Shared application header with clickable logo and standardized right-side controls.
 * Right side order: [page-specific] → Help (?) → [page-specific gear] → Home → UserMenu
 *
 * @param {ReactNode} pageActions - Page-specific controls (settings gear, etc.) rendered between Help and Home
 */
export default function AppHeader({ pageActions }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-surface-1 px-3 py-2 sm:p-4 flex items-center justify-between h-[56px] sm:h-[73px]">
      {/* Left: Clickable logo */}
      <button
        onClick={() => !isHome && navigate('/')}
        className={`flex items-center space-x-2 sm:space-x-3 transition-opacity duration-200 ${isHome ? 'cursor-default' : 'hover:opacity-80 cursor-pointer'}`}
        aria-label="Go to main menu"
      >
        <IconDaggerheart className="w-7 h-7 sm:w-8 sm:h-8 text-red-400 flex-shrink-0" />
        <span className="text-base sm:text-2xl font-bold text-gray-100 tracking-wide sm:tracking-wider font-serif truncate">
          Chaggerheart
        </span>
      </button>

      {/* Right: Standardized controls */}
      <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
        <HelpButton />
        {pageActions}
        {!isHome && (
          <button
            onClick={() => navigate('/')}
            className="p-1.5 sm:p-2 text-gray-400 hover:text-red-400 transition-colors duration-200"
            aria-label="Home"
            title="Home"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </button>
        )}
        <UserMenu />
      </div>
    </header>
  );
}
